<app-layout>
    <router-outlet name="home"></router-outlet>
</app-layout>